import React, { useState, useEffect, useRef } from 'react';
import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import { useContextData } from '../ContextData';
import * as request from "../../services/FetchService";
import { staticSort } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import ReactMarkdown from 'react-markdown';
import NewButton from '../Buttons/NewButton';

const OpenSupportTicketModal = ({ show, setShow, ticketId, setTicketId, onClose, updateList }) => {
    const bottomRef = useRef(null);
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false)
    const [comments, setComments] = useState([])
    const [ticketOpen, setTicketOpen] = useState(false)
    const [loading, setLoading] = useState(true)
    const [AIInfo, setAIInfo] = useState()
    const [AIThinking, setAIThinking] = useState(false)
    const inputFile = useRef(null);
    const [attachments, setAttachments] = useState([]); // [{id,name,file}]
    const [messageSending, setMessageSending] = useState(false)



    const handleClose = () => {
        onClose()
        setComments([])
        setTicketOpen(false)
        setAIInfo(null)
        setAIThinking(false)
        setLoading(true)
        setTicketId(null)
        setAttachments([])
      //  setShow(false)
    }
    const getSpecificTicket = () => {
        const data = {
            ticketid: ticketId
        }
        request.post("", "account/support/tickets/specific", data).then((response) => {
            const status = response?.data?.ticket?.can_reply
            setLoading(false)
            setTicketOpen(status)
            setShow(true)
            const sorted = staticSort(response?.data?.ticket?.comments, "created_at")
            setComments(sorted)        
            setAIInfo(response?.data?.ticket?.ai_suggestion)
            toast.dismiss("opening");
            setAIThinking(false)
            //setTicketId(null)

        }); 
    }

    useEffect(() => {
        if (!loading && comments?.length > 0) {
            setTimeout(() => {
               bottomRef.current?.scrollIntoView({ behavior: "auto" });
            }, 50);
        }
    }, [loading, comments]);

    useEffect(() => {
       // getDevices()
        if(ticketId){
            getSpecificTicket()
        }
    }, [ticketId])

    const sendMessage = async () => {
        console.log("TICKET ID?: ", ticketId)
        setMessageSending(true)
        if(!message || message === ""){
            setMessageSending(false)
            toast.error(t("toast.no_message"))
            return
        }
        const formData = new FormData();
        formData.append("ticketid", ticketId);
        formData.append("message", message);
        // Add each file
        attachments.forEach((a) => {
            formData.append("files", a.file, a.name);
        });

        request.postWithFiles("", "account/support/tickets/update", formData).then((response) => {
            if(response.data.successful){
                toast.success(t("toast.sent"))
                getSpecificTicket()
                setMessage("")
                updateList()
                setAttachments([])
                setMessageSending(false)
            }else{
                toast.error(response?.data?.message)
                 setMessage("")
                updateList()
                setAttachments([])
                setMessageSending(false)
            }
		}); 
    }

    const replyAi = async(feedback) => {
        setAIThinking(true)
        const data = {
            ticketid: ticketId,
            feedback: feedback
        }

        request.post("", "account/support/tickets/ai/feedback", data).then((response) => {
            if(response.data.successful){
                getSpecificTicket()
                setMessage("")
                updateList()
            }
		}); 
    }

    const deleteTicket = () => {

    }

    const AiSection = () => {
        if(AIThinking){
            return(
                <div className={`markdown-body chatbubble p-3 bg-light-grey align-self-start rounded24 mt-auto`}>
                    <ReactMarkdown>{"..."}</ReactMarkdown>
                </div>
            )
        }
        if(AIInfo?.status === "accepted"){
            return(
                <div className={`markdown-body chatbubble p-3 bg-light-grey align-self-start rounded24 mt-auto`}>
                    <img className="size_15" src={icons.battery_empty} alt="" />
                    <ReactMarkdown>{AIInfo?.text}</ReactMarkdown>
                    <p className="dark_grey mt-2">{t("settings.ai_disclaimer")}</p>
                    <div className="d-flex w-100 justify-content-between pt-2 mt-2 border-settings-top">
                        <Button onClick={() => replyAi("good")} btnClass={`btn-primary gradient-button-primary me-2 w-50`}>{t("settings.yes_close_ticket")}</Button>
                        <Button onClick={() => replyAi("bad")} btnClass={`btn-primary ms-2 w-50`}>{t("settings.no_keep_ticket_open")}</Button>
                    </div>
                </div>
            )   
        }
        if(AIInfo?.status === "questioned"){
            return(
                <div className={`markdown-body chatbubble p-3 bg-light-grey align-self-start rounded24 mt-auto`}>
                    <img className="size_15" src={icons.battery_empty} alt="" />
                    <ReactMarkdown>{AIInfo?.text}</ReactMarkdown>
                    <div className="d-flex w-100 justify-content-between mt-3">
                        <Button onClick={() => replyAi("accepted")} btnClass={`btn-primary gradient-button-primary me-2 w-50`}>{t("settings.yes")}</Button>
                        <Button onClick={() => replyAi("declined")} btnClass={`btn-primary ms-2 w-50`}>{t("settings.no")}</Button>
                    </div>
                </div>
            )
        }
        if(AIInfo?.status === "good"){
            return(
                <div className={`markdown-body chatbubble p-3 bg-light-grey align-self-start rounded24 mt-auto`}>
                    <img className="size_15" src={icons.battery_empty} alt="" />
                    <ReactMarkdown>{AIInfo?.text}</ReactMarkdown>
                </div>
            )
        }
    }

  const uploadHandler = () => inputFile.current?.click();

  const handleUploadedFiles = (filesList) => {
    if (!filesList || filesList.length === 0) return;
    const files = Array.from(filesList).map((file) => ({
      id: crypto.randomUUID(),
      name: file.name,
      file,
    }));
    setAttachments((prev) => [...prev, ...files]);

    // allow selecting the same file again later
    if (inputFile.current) inputFile.current.value = "";
  };

  const removeAttachment = (id) =>
    setAttachments((prev) => prev.filter((a) => a.id !== id));

  const clearAll = () => setAttachments([]);
    
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} maxWidth="md" open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100">
                    <div className="p-3 grey-blue">
                        <div className="d-flex flex-row justify-content-between align-items-center">
                            <div className='d-flex align-items-center'>
                                <h3 className="">{t("settings.ticket")}</h3>
                            </div>
                            <img className="cursor-pointer" src={icons.close_gray} onClick={() => handleClose()} alt="..." /> 
                        </div>
                        <div className="mt-3 d-flex flex-column ticket-list w-100 text-break scrollable-y">
                            {comments?.map((comment, index) => {
                                return(
                                    <div key={index} className={`markdown-body chatbubble rounded24 p-3 mb-3 ${comment.from === "user" ? "bg-primary align-self-end" : "bg-light-grey align-self-start"}`}>
                                        {comment?.attachments?.map((atch, index) => (
                                        <img key={index} className="markdown-body mb-3" src={atch?.content_url} alt=""/> 
                                        ))}
                                        <ReactMarkdown>{comment.body}</ReactMarkdown>
                                        {/* <p>{comment?.body}</p> */}
                                    </div>
                                )
                            })}
                            <div ref={bottomRef} />
                            <AiSection />
                        </div>

                        <div className={`mt-3 ${ticketOpen ? "" : "d-none"}`}>
                            <NewButton onClick={uploadHandler} icon={icons.plus_circle} iconClass={"grey-blue-icon size_15"} className="bg-grey grey-blue rounded24 p bold">
                                {attachments.length > 0 ? t("settings.add_more") : t("settings.upload_file")}
                            </NewButton>
                            <div className="mt-2">
                                {attachments.length > 0 && (
                                    <div className="d-flex flex-wrap">
                                       {attachments.map((a) => (
                                            <div key={a.id} className="d-flex align-items-center justify-content-start px-2 py-1  w-100"
                                            >
                                                <NewButton 
                                                    onClick={() => removeAttachment(a.id)}
                                                    className="full-rounded bg-red me-2 p-1" 
                                                    notext={true} 
                                                    icon={icons.close} 
                                                    iconClass={"white-icon w-100 h-100 size_12"} />
                                                <p className="grey-blue text-truncate">{a.name}</p>
                                            </div>
                                            ))} 
                                    </div>
                                )}
                            </div>
                            <input
                                type="file"
                                id="file"
                                accept="*/*"
                                className="cursor-pointer invisible"
                                onChange={(e) => handleUploadedFiles(e.target.files)}
                                ref={inputFile}
                                style={{ display: "none" }}
                            />
                            <textarea 
                                rows={5}
                                value={message}
                                onChange={(event) => setMessage(event.target.value)} 
                                className="form-control text-area-boy bg-light-grey rounded24" />  
                        </div>
                        <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                            {/* <NewButton onClick={() => deleteTicket()} className="bg-red rounded24 w-25 me-2 p-3 body bold me-auto white">{t("settings.delete")}</NewButton> */}
                            <NewButton onClick={() => handleClose()} className={`bg-grey rounded24 w-50 dark-grey ms-2 p-3 body bold ${ticketOpen ? "me-2" : ""}`}>{ticketOpen ? t("settings.close") : t("settings.close")}</NewButton>
                            <NewButton onClick={() => sendMessage("")} className={`bg-gradient rounded24 w-50 white-white ms-2 p-3 body bold ${ticketOpen ? "" : "d-none"} ${messageSent || messageSending ? "disabled" : ""}`}>{messageSent ? t("settings.sent") : t("settings.send")}</NewButton>

                        </div>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default OpenSupportTicketModal;